import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { userRankingAtom } from "../atoms/userRankingAtom";
import { useNavigate } from "react-router-dom";
import { SocketProps } from "../types/interface";
import { history } from "../history";

const AnimatedScore = ({ score }: { score: number }) => {
  const [displayedScore, setDisplayedScore] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = Math.max(Math.floor(score / 50), 1); // Adjust increment to make animation smooth

    const interval = setInterval(() => {
      start += increment;
      if (start >= score) {
        start = score;
        clearInterval(interval);
      }
      setDisplayedScore(start);
    }, 50); // Adjust interval time to control speed

    return () => clearInterval(interval);
  }, [score]);

  return <>{displayedScore} point</>;
};

const FallingIcons = () => {
  const [icons, setIcons] = useState<string[]>([]);

  useEffect(() => {
    const iconArray = Array(10).fill("🏆"); // 10개의 아이콘 생성
    setIcons(iconArray);

    const timer = setTimeout(() => {
      setIcons([]);
    }, 4000); // 4초 후 아이콘 제거

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
      {icons.map((icon, index) => (
        <div
          key={index}
          className="absolute top-0 text-4xl animate-fall"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
          }}
        >
          {icon}
        </div>
      ))}
    </div>
  );
};

const ShowRanking: React.FC<SocketProps> = ({ socket }) => {
  const navigate = useNavigate();
  const userInfo = useRecoilValue(userRankingAtom);
  //   console.log("아톰에 들어있는 정보 쇼랭킹!!!", userInfo);

  const exitRoom = () => socket.emit("exit_room");
  useEffect(() => {
    const unlistenHistoryEvent = history.listen(({ action }) => {
      if (action === "POP") {
        exitRoom();
      }
    });

    return unlistenHistoryEvent;
  }, []);

  const sortedUsers: any[] = Array.isArray(userInfo)
    ? userInfo.slice().sort((a: any, b: any) => b.point - a.point)
    : [];

  const onNavigateHome = () => {
    exitRoom();
    navigate("/fun_learning/home");
  };

  //   console.log("이긴팀!!!!!!!!", userInfo[0].winningTeam);

  return (
    <div className="h-lvh dark:bg-gray-700 bg-gray-200 pt-12 pb-5 relative ">
      <FallingIcons />
      <div className="dark:text-slate-200 font-bold text-slate-800 text-xl text-center max-w-sm mx-auto">
        <button
          onClick={onNavigateHome}
          className="mt-3 inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:bg-gradient-to-b dark:shadow-blue-900 shadow-blue-200 hover:shadow-2xl hover:shadow-blue-400 hover:-translate-y-px"
        >
          협력학습방으로 돌아가기
        </button>
      </div>
      <div className="text-5xl text-center max-w-sm mx-auto mt-5 mb-3">🏆</div>
      {sortedUsers.length === 0 ? (
        <div className="dark:text-slate-200 font-bold text-slate-800 text-2xl text-center max-w-sm mx-auto mt-5 mb-3">
          랭킹 데이터가 없습니다.
          <br />
          내정보에서 확인해주세요.
        </div>
      ) : (
        <div>
          <div className="dark:text-slate-200 font-bold text-slate-800 text-2xl text-center max-w-sm mx-auto mt-5 mb-3">
            {userInfo[0].winningTeam === undefined
              ? "이번 협력학습의 랭킹!"
              : `이긴 팀은 ${userInfo[0].winningTeam}!`}
          </div>
          <div className="dark:text-slate-200 font-bold text-slate-800 text-sm text-center max-w-sm mx-auto mt-5 mb-3">
            {userInfo[0].winningTeam === undefined
              ? ""
              : `이긴 팀에게는 보너스 점수가 5점이 주어집니다!`}
          </div>
        </div>
      )}
      <audio autoPlay src="audio/goodresult.mp3">
        오디오다 public 경로는 매핑시 /로 매핑!!!
      </audio>
      {sortedUsers.length === 0 ? (
        ""
      ) : (
        <table className="mx-auto bg-white dark:bg-gray-900 rounded-lg shadow-lg mb-10 max-h-80 overflow-y-auto">
          <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                랭킹
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                아이디
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                팀
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                점수
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
            {sortedUsers.map((user: any, index: any) => {
              return (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        {`#${index + 1}`}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 dark:text-gray-200">
                      {user.id}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-teal-100 text-teal-800 dark:bg-teal-700 dark:text-teal-200">
                      {user.team === "" ? "개인전" : `${user.team}`}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {user.winningTeam === undefined ? (
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-700 dark:text-blue-200">
                        <AnimatedScore score={user.point} />
                      </span>
                    ) : user.winningTeam === user.team ? (
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-700 dark:text-yellow-200">
                        <AnimatedScore score={user.point} />
                      </span>
                    ) : (
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-700 dark:text-blue-200">
                        <AnimatedScore score={user.point} />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ShowRanking;
